/* eslint-env browser, node */
/* eslint no-mixed-operators: 0, spaced-comment: 0, brace-style: 0, indent: 0 */
import precise from './precise';
import getPipeValue from './getPipeValue';

/**
 * Calculate the penalty fees from a pipe object.
 * @description This logic was refactored from the validation calculation on
 * the PDFs Rsub2 text field (penalty total) as well as the DynoListLease dropdown.
 * @param  {object} pipe The current pipe object from vehicle selection.
 * @return {number|array}  The penalty fee with optional message.
 */
function getPenaltiesFromPipeAndWeight(pipeString, _vehicleWeight, applyPenaltyFee) {
  if (!applyPenaltyFee) {
    return precise(0);
  }

  const r18 = getPipeValue(pipeString, 'r18');
  let val = isNaN(Number(r18)) ? 0 : Number(r18);

  const W = Math.round(Number(_vehicleWeight) / 100);

  //console.log('getPenaltiesFromPipeAndWeight:', { val, r18, W });

  if (val === 2) {
    alert('Renewal Penalty Fee not charged on this Vehicle/Vessel Type');
    return precise(0);
  }

  // Because John liked to do everything on the global state
  // this r18 check is repeated (from various Vehicle Dropdown onChange handlers)
  // to ensure that r18 will equal the amounts he would specify in the global
  // state (and the code down below should behave as planned, while still being
  // modular). All of John's "pipe" code needs to be refactored and the pipes removed.

  // from leases dropdown
  if (r18 === 'pa') // penalty auto
  {
      val = ((17.00) + (1.50 * W));
  }
  else if (r18 === 'pa66') // penalty auto 6 months
  {
      val = ((17.00) + (1.50 * W));
  }
  else if (r18 === 'ptp') // penalty trailer hire 2000 & over
  {
      val = ((13.50) + (1.50 * W));
  }
  else if (r18 === 'pt') // penalty trailer hire <2000
  {
      val = ((3.50) + (1.50 * W));
  }

  // from buses dropdown
  if (r18 === 'pb') // penalty bus
  {
      val = (((((17.00) + (2.00 * W)) / 12) * 12));
  }
  if (r18 === 'pt') // penalty trailer
  {
      val = (((((3.50) + (1.00 * W)) / 12) * 12));
  }
  if (r18 === 'ps') // penalty bus 6 month
  {
      val = (2.50 + (((((17.00) + (2.00 * W)) * 0.50) / 12) * 12));
  }

  if (val !== 0 || val !== 1) {
    if (val >= 5.00 && val < 25.00) {
      return precise(5);
    }
    if (val >= 25.00 && val < 50.00) {
      return precise(10);
    }
    if (val >= 50.00 && val < 100.00) {
      return precise(15);
    }
    if (val >= 100.00 && val < 400.00) {
      return precise(50);
    }
    if (val >= 400.00 && val < 600.00) {
      return precise(100);
    }
    if (val >= 600.00) {
      return precise(250);
    }
    return precise(0);
  }
  return precise(0);
}

export default getPenaltiesFromPipeAndWeight;
